"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSession = exports.getAuthSession = exports.hasSession = exports.removeSession = exports.getSessionHeaders = exports.setSessionId = exports.getSessionId = exports.CookieValues = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const query_params_util_1 = require("./query-params-util");
const header_util_1 = require("./header-util");
const internal_api_util_1 = __importDefault(require("../../@internal/api/internal-api-util"));
const config_1 = __importDefault(require("../../@internal/config"));
const { services: { gatekeeper: { url: GATEKEEPER_URL } } } = config_1.default;
var CookieValues;
(function (CookieValues) {
    CookieValues["SESSION"] = "session";
})(CookieValues = exports.CookieValues || (exports.CookieValues = {}));
const getSessionId = () => {
    return js_cookie_1.default.get(CookieValues.SESSION);
};
exports.getSessionId = getSessionId;
const setSessionId = (sessionId) => {
    return js_cookie_1.default.set(CookieValues.SESSION, sessionId);
};
exports.setSessionId = setSessionId;
const getSessionHeaders = () => {
    const sessionId = (0, exports.getSessionId)();
    return Object.assign({}, (sessionId && { [header_util_1.Header.SESSION]: sessionId }));
};
exports.getSessionHeaders = getSessionHeaders;
const removeSession = () => {
    js_cookie_1.default.remove(CookieValues.SESSION);
};
exports.removeSession = removeSession;
const hasSession = () => ((0, exports.getSessionId)() ? true : false);
exports.hasSession = hasSession;
const getAuthSession = () => {
    const params = (0, query_params_util_1.parseQueryParams)(window.location.search);
    const sessionOnRouteParams = params === null || params === void 0 ? void 0 : params.session;
    if (sessionOnRouteParams) {
        (0, exports.setSessionId)(sessionOnRouteParams);
        delete params['session'];
        const queryParams = (0, query_params_util_1.buildSearchQueryParams)(params);
        window.history.replaceState(null, '', `${window.location.pathname}${queryParams}`);
        return sessionOnRouteParams;
    }
    const session = (0, exports.getSessionId)();
    return session;
};
exports.getAuthSession = getAuthSession;
const validateSession = (sessionId) => {
    return internal_api_util_1.default.get(`${GATEKEEPER_URL}/sessions/${sessionId}`);
};
exports.validateSession = validateSession;
